// extracted by mini-css-extract-plugin
export var lg = "_1i-4";
export var md = "_1i-3";
export var sm = "_1i-2";
export var xs = "_1i-1";
export var xxs = "_1i-0";